import { CAPABILITY_FLAGS, type ModelCapabilityKey } from "./modelCapabilities";

export interface ModelCapabilityFlagsProps {
  idPrefix: string;
  /** Current on/off state for each capability flag. */
  values: Record<ModelCapabilityKey, boolean>;
  onChange: (key: ModelCapabilityKey, checked: boolean) => void;
}

/** The grid of behavioral capability flags (reasoning, vision, tools, ...). */
export function ModelCapabilityFlags({ idPrefix, values, onChange }: Readonly<ModelCapabilityFlagsProps>) {
  return (
    <div>
      <span className="block text-sm font-medium text-content-secondary mb-2">Model Capabilities</span>
      <p className="text-xs text-content-quaternary mb-3">
        These flags control how the backend interacts with this model (e.g., whether temperature is sent, which tools
        are available).
      </p>
      <div className="grid grid-cols-2 gap-2">
        {CAPABILITY_FLAGS.map((flag) => (
          <label // NOSONAR - label wraps checkbox + visible text (flag.label)
            key={flag.key}
            htmlFor={`${idPrefix}-flag-${flag.key}`}
            className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
              values[flag.key]
                ? "bg-brand-primary/10 border-brand-primary/30"
                : "bg-surface-secondary border-border-secondary hover:border-border-primary"
            }`}
          >
            <input
              id={`${idPrefix}-flag-${flag.key}`}
              type="checkbox"
              checked={values[flag.key]}
              onChange={(e) => onChange(flag.key, e.target.checked)}
              className="mt-0.5 w-4 h-4 rounded-sm border-border-secondary text-brand-primary focus:ring-brand-primary"
            />
            <div>
              <span className="text-sm font-medium text-content-primary">{flag.label}</span>
              <p className="text-xs text-content-quaternary">{flag.description}</p>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
